import { render } from "./basic-info-request.vue?vue&type=template&id=106b644e&scoped=true"
import script from "./basic-info-request.vue?vue&type=script&lang=js"
export * from "./basic-info-request.vue?vue&type=script&lang=js"

import "./basic-info-request.vue?vue&type=style&index=0&id=106b644e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106b644e"]])

export default __exports__